import { render } from "./Referrals.vue?vue&type=template&id=ba365852"
import script from "./Referrals.vue?vue&type=script&lang=js"
export * from "./Referrals.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/web-frontend-dev/web-frontend-dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__